import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';

export const theme = createTheme({
  palette,
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: '#FFFFFF',
          backgroundColor: '#121212',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.38)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          backgroundColor: '#0C0E14',
          borderRadius: '1.25rem',
          transition: 'border-radius 0.2s ease-in-out',
          boxShadow:
            '0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',

          '&.Mui-focused, &.MuiOutlinedInput-root[aria-expanded="true"]': {
            borderRadius: '1.25rem 1.25rem 0 0',
            backgroundColor: '#0C0E14',
          },
        },
        notchedOutline: {
          borderColor: 'rgba(23, 172, 243, 0.5)',
          '.MuiOutlinedInput-root:hover &': {
            borderColor: 'rgba(41, 182, 246, 1)',
          },
          '.MuiOutlinedInput-root.Mui-focused &': {
            border: 'none',
            borderBottom: '1px solid rgba(51, 184, 247, 0.9)',
          },
          '.MuiOutlinedInput-root.Mui-disabled &': {
            borderColor: 'rgba(255, 255, 255, 0.23) !important',
          },
        },
        input: {
          color: '#ffffff',
          backgroundColor: 'transparent',
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #0C0E14 inset',
            WebkitTextFillColor: '#ffffff',
            caretColor: '#ffffff',
            transition: 'background-color 5000s ease-in-out 0s',
          },
          '&:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
            WebkitBoxShadow: '0 0 0 100px #0C0E14 inset',
            WebkitTextFillColor: '#ffffff',
            caretColor: '#ffffff',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#666666',
          '&.Mui-focused': {
            color: '#247CDE',
          },
        },
      },
    },
  },
});
